import React, { ReactElement, useState } from 'react'
import { scrollingContainerRef } from 'components/Dashboard/DashboardScrollingContainer'
import { DeletionType } from 'ui/ConfirmDeletionModalDialog/ConfirmDeletionContent'
import { getTimeSinceNow } from 'utils/getTimeSinceNow'
import ConfirmDeletionModalDialog from 'ui/ConfirmDeletionModalDialog'
import { useDeleteDeviceMutation } from 'store/api/devices'
import { endActivityLogSession } from 'store/activityLog'
import { useAppDispatch } from 'store/hooks'
import { Setter } from 'utils'

export default function DeleteDeviceConfirmation({
  dismiss,
  lastActivity,
  deviceToDeletePk,
  setDeviceToDeletePk,
}: {
  dismiss: () => void
  lastActivity?: number
  deviceToDeletePk?: string
  setDeviceToDeletePk: Setter<string>
}): ReactElement {
  const dispatch = useAppDispatch()
  const [deleteDevice, { isLoading: isDeletionDeviceLoading }] = useDeleteDeviceMutation()
  const [isRequestInFlight, setIsRequestInFlight] = useState(false)

  return (
    <ConfirmDeletionModalDialog
      element={scrollingContainerRef.current}
      title="Delete Endpoint"
      onClose={dismiss}
      type={DeletionType.DEVICE}
      isRequestInFlight={isDeletionDeviceLoading || isRequestInFlight}
      timeSinceLastQuery={getTimeSinceNow(lastActivity)}
      notificationText="Deleting an active Endpoint will instantly break Internet on every machine that uses this resolver."
      checkboxText="I understand that deleting this endpoint is permanent and can’t be undone."
      onCancel={() => {
        setDeviceToDeletePk('')
        dismiss()
      }}
      onDelete={() => {
        setIsRequestInFlight(true)
        dispatch(endActivityLogSession())
        deleteDevice({
          pk: deviceToDeletePk || '',
        })
          .unwrap()
          .then(() => {
            setDeviceToDeletePk('')
            dismiss()
          })
          .catch(() => {})
          .finally(() => setIsRequestInFlight(false))
      }}
    />
  )
}
